import { IntlMessageFormat } from 'intl-messageformat'
import { getInterfaceLocale, normalizeLocale } from './config'

const formatters = new Map()
const MAX_FORMATTERS = 200

// Keep the language of the selected text: fallback messages need that language's plural rules.
export const resolveTranslatorEntry = (entry, locale, code) => {
  if (typeof entry === 'string') return { title: entry, locale, icuFormat: false }
  if (typeof entry?.title === 'string') return entry

  const translations = entry?.translations || {}
  const candidates = [locale, normalizeLocale(locale), getInterfaceLocale(locale), ...Object.keys(translations)]
  for (const candidate of candidates) {
    const title = translations[candidate]?.title
    if (title) return { title, locale: candidate, icuFormat: entry?.icuFormat === true }
  }
  return { title: code, locale, icuFormat: false }
}

export const formatTranslatorEntry = (entry, locale, code, parameters = {}) => {
  const resolved = resolveTranslatorEntry(entry, locale, code)
  if (!resolved.icuFormat) return resolved.title

  try {
    const key = `${resolved.locale}\0${resolved.title}`
    let formatter = formatters.get(key)
    if (!formatter) {
      formatter = new IntlMessageFormat(resolved.title, resolved.locale, undefined, { ignoreTag: true })
      if (formatters.size >= MAX_FORMATTERS) formatters.delete(formatters.keys().next().value)
      formatters.set(key, formatter)
    }
    return String(formatter.format(parameters))
  } catch {
    // Missing parameters or incompatible patterns must not crash the page or expose ICU source.
    return code
  }
}
